import React, { useEffect } from 'react';
import { useLoaderData, useOutletContext } from 'react-router-dom';

import ManageDashboard from '../../components/ManageDashboard';

export default function EditDashboard() {
    const dashboard = useLoaderData();
    const { setDashboardId, setDashboardName } = useOutletContext();

    useEffect(() => {
        setDashboardName(dashboard.name);
        setDashboardId(dashboard.id);
    }, [dashboard]);

    return (
        <div data-testid="route-dashboards-edit">
            <ManageDashboard dashboard={dashboard} action={'update'} />
        </div>
    );
}
